<template>
  <div class="wrapBox">
    <div class="topBox"></div>
    <div class="header-title border-bottom">房源已锁定!</div>
    <div class="house-info">
      <div class="title">所选房源</div>
      <div class="info">{{orderData.houseInfo}}</div>
      <!-- <p class="houseBox">
        <span class="hs1">订单编号</span>
        <span class="hs2">{{ orderData.hfOrderCode }}</span>
      </p> -->
      <p class="houseBox">
        <span class="hs1">置业顾问</span>
        <span class="hs2">{{ orderData.saleMen }}</span>
      </p>
      <p class="houseBox">
        <span class="hs1">房源</span>
        <span class="hs2">{{ orderData.houseInfo }}</span>
      </p>
      <p class="houseBox">
        <span class="hs1">客户</span>
        <span class="hs2">{{ orderData.mainUserName }}</span>
      </p>
      <p class="houseBox hBox1">
        <span class="hs1">电话</span>
        <span class="hs2">{{ orderData.mainUserPhone }}</span>
      </p>
      <p class="houseBox">
        <span class="hs1">身份证</span>
        <span class="hs2">{{ orderData.mainCodeId }}</span>
      </p>
    </div>
    <div class="house-info otherHouse" v-for="(item,index) in showOther" :key="index">
      <p class="houseBox">
        <span class="hs1">客户{{index+2}}</span>
        <span class="hs2">{{ item.customerName }}</span>
      </p>
      <p class="houseBox">
        <span class="hs1">关系</span>
        <span class="hs2">{{ item.relationshipName }}</span>
      </p>
      <p class="houseBox">
        <span class="hs1">客户</span>
        <span class="hs2">{{ orderData.mainUserName }}</span>
      </p>
      <p class="houseBox">
        <span class="hs1">电话</span>
        <span class="hs2">{{ item.telPhone }}</span>
      </p>
      <p class="houseBox" v-show="item.documentNumber">
        <span class="hs1">身份证</span>
        <span class="hs2">{{ item.documentNumber }}</span>
      </p>
    </div>
    <div class="house-info otherHouse">
      <p class="houseBox">
        <span class="hs1">销售面积</span>
        <span class="hs2">{{ orderData.salesArea }}平方米</span>
      </p>
      <p class="houseBox">
        <span class="hs1">单价</span>
        <span class="hs2">{{ orderData.houseFacePrice }}元/平方米</span>
      </p>
      <p class="houseBox">
        <span class="hs1">总价</span>
        <span class="hs2">{{ formatMoney(orderData.houseSumFacePrice) }}元</span>
      </p>
    </div>
    <!-- <div class="plan">
      <p>收款计划</p>
      <p class="planTitle">大定金</p>
      <div class="planBox">
        <p>计划收款时间:{{payTime}}</p>
        <p class="pw">计划收款金额:{{ deMoney }}</p>
      </div>
      <p class="planTitle">一次性全款</p>
      <div class="planBox">
        <p>计划收款时间:{{payTime}}</p>
        <p class="pw">计划收款金额:{{orderData.houseSumFacePrice}}</p>
      </div>
    </div> -->
    <div class="money-info">
      <div class="lable">定金</div>
      <div class="info">¥{{deMoney}}</div>
    </div>
    <div class="line-layer"></div>
    <div class="money-warn">*请在规定时间内支付定金，否则您所选择的房源将会取消锁定</div>
    <div class="wranTitle">
      <p class="line"></p>
      <p class="wran">温馨提示</p>
      <p class="line"></p>
    </div>
    <div class="wranText">支付前请确认您选择的房源和支付款项</div>
    <p class="sureBtn" @click="creatOrder()" v-show="PayMoneyFlag">立即支付</p>
    <p class="sureBtn noSure" @click="noCreat()" v-show="!PayMoneyFlag">立即支付</p>
    <p class="timeBox" v-show="timeShow"><span>倒计时:</span>{{showTimeLeft}}</p>
  </div>
</template>
<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox , Indicator} from "mint-ui";
import request from "@/utils/request";
import wxsdk from "@/utils/wxsdk";
import Cookies from "js-cookie";
import "./components/all.css";
export default {
  components: {},
  data() {
    return {
      openid: Cookies.get("openid"),
      projectId: this.$route.query.pid ? parseInt(this.$route.query.pid) : 2343,
      orderId: this.$route.query.orderId ? this.$route.query.orderId : '',
      payaccount: "",
      orderData:{
        houseInfo: "",  //房源名字
        hfOrderCode: "",  //订单编号
        saleMen: "",
        // houseInfo2: "",
        mainUserName: "",  //主要购买人
        mainUserPhone: "",
        amount: "",  //定金
        customerId:"",   //客户id
        paymentPlanId:"",  //计划收款id
        houseCode: "",    //房源id
        houseSumFacePrice: "",    //房源总价
        houseFacePrice: "",    //房源单价
        salesArea: "",    //销售面积
        expireTime:"",
        mainCodeId: ""   //注册人的身份证
      },
      payMentPlan:"",
      payTime: "",
      showOther:null,
      showThis:null,
      canPay: true,
      PayMoneyFlag:true,
      timeLeft: 0,
      bundleIntervalEvent: "",
      wxOrder: "",  //微信订单   海亮接口返回obj   使用JSON.stringfy后直接传到dm中
      deMoney: "",
      timeShow: false
    };
  },
  computed: {
    //用计算属性显示结果
    showTimeLeft() {
      //剩余秒数<=0
      if (this.timeLeft <= 0) {
        // 结束event
        this.canPay = false;
        this.PayMoneyFlag = false
        return "已过期";
      }
      // 剩余秒数>0
      else {
        this.canPay = true;
        this.PayMoneyFlag = true
        // let day = Math.floor(this.timeLeft / 86400);
        let hour = Math.floor((this.timeLeft % 86400) / 3600);
        let min = Math.floor(((this.timeLeft % 86400) % 3600) / 60);
        let sec = Math.floor(((this.timeLeft % 86400) % 3600) % 60);
        // return (day + "天  " + (hour < 10 ? "0" : "") + hour + ": " + (min < 10 ? "0" : "") + min + ": " + (sec < 10 ? "0" : "") + sec);
        return ((hour < 10 ? "0" : "") + hour + "时" + (min < 10 ? "0" : "") + min + "分" + (sec < 10 ? "0" : "") + sec + '秒');
      }
    },
    formatMoney() {
      return function(n) {
        return util.formatMoney(n)
      }
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      //	      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m;
    }
  },
  methods: {
      getPayDetail(){
        let that = this;
        Indicator.open({
            text: "信息加载中...",
            spinnerType: "fading-circle"
        });
        console.log(that.orderId)
        const otherUser = [];
        const payMent = [];
        const thisUser = []
        if(that.orderId == ''){
            MessageBox.alert('未获取到具体的支付信息,请联系置业顾问')
        }else{
            request
            .get(that.global.API_URL, {
                action: "/hf/PurchasingPlanAction/getOrderInfo",
                requestParam: { orderId: that.orderId }
                })
                .then(function(data) {
                console.log(data.obj);
                that.orderData = data.obj

                // that.orderData.houseInfo = data.obj.order.periodName + "-" + data.obj.order.houseResource.unit + "-" + data.obj.order.houseResource.saleFloorRoomName
                that.orderData.houseInfo = data.obj.order.periodName + "-" + data.obj.order.houseResource.buildingName + "-" + data.obj.order.houseResource.unit + "-" + data.obj.order.houseResource.saleFloorRoomName
                that.orderData.hfOrderCode = data.obj.order.id
                that.orderData.saleMen = data.obj.order.createUser
                that.orderData.houseInfo2 = data.obj.order.houseResource.houseType.composition
                that.orderData.mainUserName = data.obj.order.customerName
                that.orderData.mainUserPhone = data.obj.order.customerPhoneNum
                // that.orderData.amount = data.obj.order.deposit
                that.orderData.customerId = data.obj.order.customer.id
                that.orderData.houseCode = data.obj.order.houseResource.id
                that.orderData.salesArea =  data.obj.order.salesArea
                // that.orderData.houseSumFacePrice = that.toMoney(data.obj.order.houseResource.houseSumFacePrice)
                that.orderData.houseSumFacePrice = data.obj.order.houseResource.houseSumFacePrice
                that.orderData.houseFacePrice = data.obj.order.houseResource.houseFacePrice
                that.orderData.expireTime = data.obj.order.payValidTime
                console.log(data.obj.orderConCusList)
                // 获取联名购买人
                data.obj.orderConCusList.forEach(item => {
                    console.log(item)
                    if(item.customerTypeNum != 10){
                        otherUser.push(item)
                    }else{
                        thisUser.push(item)
                    }
                })
                console.log(otherUser)
                console.log(thisUser)
                that.showOther = otherUser;
                that.orderData.mainCodeId = thisUser[0].documentNumber
                // 根据订单对应的状态进行拦截判断
                if(data.obj.order.orderStatus == 40){
                  Indicator.close();
                  MessageBox.alert("该订单已作废","提示")
                  return
                }
                // 获取收款计划
                data.obj.collectionPlanList.forEach(item => {
                    // console.log(item)
                    if(item.paymentNameId == 1043001){
                        payMent.push(item)
                    }
                })
                console.log(payMent)
                that.payMentPlan = payMent[0]
                // that.payTime = utils.getTime(that.payMentPlan.planCollectionTime)
                that.payTime = that.getRealTime(that.payMentPlan.planCollectionTime)
                console.log(that.payMentPlan)
                Indicator.close();
                that.timeShow = true;
                //初始化剩余秒数
                that.initSecondsLeft();
                //执行间隔事件.
                that.bundleIntervalEvent = setInterval(that.intervalEvent, 1000);
            });
        }
      },
      // 获取配置i信息
      getConfig() {
        let that = this;
        let deMoney = '';
        request
          .get(that.global.API_URL, {
              action: "/house/HouseOnlineAction/getConfig",
              requestParam: { projectId: that.projectId }
          }).then(function(data) {
              console.log(data)
              that.payaccount = data.obj.payaccount
              console.log(that.toMoney((data.obj.deposit/100).toString()))
              deMoney = (data.obj.deposit/100).toString()
              that.deMoney = deMoney
          })
      },
      // 不能支付
      noCreat(){
        let that = this;
        MessageBox.alert("订单已作废或支付时间已过，请联系您的销售顾问查看详情")
      },
      creatOrder(){
        let that = this;
        let params = {
          projectId: that.projectId,
          name: that.orderData.mainUserName,
          mobile: that.orderData.mainUserPhone,
          hfOrderCode: that.orderData.hfOrderCode,
          customerId: that.orderData.customerId,
          houseInfo: that.orderData.houseInfo,
          // paymentPlanId: that.payMentPlan.payDetId,
          paymentPlanId: that.payMentPlan.id,
          houseCode: that.orderData.houseCode,
          openid:that.openid,
          receiptsInfo:{
            customerName: that.orderData.mainUserName,
            houseNumber: that.orderData.houseCode,
            houseName: that.orderData.houseInfo,
            // idNumber:'41282919970603361X',
            idNumber: that.orderData.mainCodeId,
            customerNumber: that.orderData.customerId,
            paymentNameId: that.payMentPlan.paymentNameId,
            paymentTypeId: that.payMentPlan.paymentTypeId,
            // paymentPlanId: that.payMentPlan.payDetId,
            paymentPlanId: that.payMentPlan.id,
            paymentName: that.payMentPlan.paymentName,
            projectId: that.payMentPlan.projectId,
            orgId: that.payMentPlan.orgId,
            saleOrgId: that.payMentPlan.saleOrgId
          }
        }
        let postParams = JSON.stringify(params)
        if(!that.canPay) {
            return;
        }
        Indicator.open({
            text: "加载中...",
            spinnerType: "fading-circle"
        });
        let payaccount = (that.payaccount ? that.payaccount : '')
        let okUrl = `${location.protocol}//${location.host}/h5/huafasubscription/PayClosePage?pid=${that.projectId}`
        let errUrl = `${location.href}&isCancel=1`; 
        let dm = `query=${encodeURIComponent(
                postParams
              )}&okurl=${encodeURIComponent(
                okUrl
            )}&errurl=${encodeURIComponent(
                errUrl
            )}`; 
        //获取支付链接
        request
        // .get('http://rushi.ttrushi.com/qc-webapp/wxapi.do', {
          .get('http://qmyx.ttrushi.com/qc-webapp/wxapi.do', {
          action: "/pay/WXPayAction/hfPaymentUrl",
          requestParam: {
            payaccount: payaccount,
            folder: "actonline",
            params: dm
          },
        })
        .then(function(data) {
          Indicator.close();
          if (data.code == 0) {
            location.href = data.obj;
            // console.log(data.obj)
          } else {
            MessageBox.alert(data.msg);
          }
        });
        console.log(dm)
      },
      // 财务数据转化
      toMoney(num) {
        if (num) {
          var newNum = num.replace("元", "");
          newNum = typeof newNum == "string" ? parseFloat(newNum) : newNum; //判断是否是字符串如果是字符串转成数字
          newNum = newNum.toFixed(2); //保留两位
          newNum = parseFloat(newNum); //转成数字
          newNum = newNum.toLocaleString(); //转成金额显示模式
          //判断是否有小数
          if (newNum.indexOf(".") == -1) {
            newNum =   newNum + ".00";
          } else {
            newNum =
              newNum.split(".")[1].length < 2
                ?  newNum + "0"
                :  newNum;
          }
          return newNum; //返回的是字符串23,245.12保留2位小数
        } else {
          return (num = null);
        }
      },
    // 收款时间处理方法（兼容ios）
    getRealTime(time){
      let date = new Date(time.replace(/-/g, "/"));
      let m = date.getMonth() + 1;
      m <= 9 ? (m = "0" + m) : m;
      let d = date.getDate();
      d <= 9 ? (d = "0" + d) : d;
      return date.getFullYear() + "-" + m + "-" + d;
    },
    // 时间处理
    initSecondsLeft() {
      let currentDate = new Date().getTime();
      let needTime = new Date((this.orderData.expireTime).replace(/-/g, "/"));
      console.log(needTime)
      let toEndDate = needTime.getTime();
      if (toEndDate > currentDate) {
        this.timeLeft = Math.floor((toEndDate - currentDate) / 1000);
      } else {
        this.timeLeft = 0;
      }
    },
    //间隔事件: 剩余秒数--, 当剩余秒数为0时,清除间隔事件.
    intervalEvent() {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        clearInterval(this.bundleIntervalEvent);
      }
    },
    // 判断是否能支付
    canPayMoney(){
      let that = this;
      request
      .get(that.global.API_URL, {
          action: "/hf/OrderAction/checkOderCanPay",
          requestParam: { hfOrderCode: that.orderId }
          })
          .then(function(data) {
            console.log(data)
            if(data.code == 0 && data.obj == 1){
              that.getPayDetail();
            }else{
              that.PayMoneyFlag = false
            }
          })
    }
  },
  mounted() {
    let that = this;
    let shareLink = util.getUrlRemoveParams();
    //设置分享
    that.global.SHARE_TITLE = `售楼中心，线上看房，实时咨询，欢迎您的光临！`;
    that.global.SHARE_DESC = `美好人居，一触即达。帮忙传播，更有多重惊喜哟！`;
    that.global.SHARE_IMG_URL =
      "http://assets.rurushishi.com/yq-rs-make/huafasubscription/hfrgShare.jpg";
    shareLink += `?pid=${this.projectid}`;
    that.global.SHARE_LINK = shareLink;
    wxsdk.init();
    that.getConfig();
    that.canPayMoney();
    // that.getPayDetail();
    comreq.getUserInfo().then(function(userInfo) {
      console.log(userInfo);
    });
  },
  beforeDestroy() {
    clearInterval(this.bundleIntervalEvent);
  }
};
</script>
<style lang="stylus" scoped>
.wrapBox {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.topBox{
  width 100%
  height 1.96rem
  background url('https://assets.rurushishi.com/yq-rs-make/huafasubscription/ttop5.png') no-repeat center
  background-size 6.7rem .84rem
  border-bottom .2rem solid #FAFAFA
}
.header-title {
  line-height: 1.2rem;
  color: #EB8C58;
  font-weight: bold;
  font-size: 16px;
  background: url('http://assets.rurushishi.com/activies/zxrc/icon_order.png') no-repeat .2rem center;
  background-size .5rem .5rem; 
  padding-left: 1rem;
  margn-left: .3rem;
}
.house-info {
  width 6.9rem
  margin 0 auto
  border-bottom 4px solid #FAFAFA
  padding-bottom .3rem
}
.house-info .title {
  font-color #333333
  font-size 16px
  position relative
  line-height 1rem
  padding-left .2rem
}
.house-info .title:before {
  position: absolute;
  content: '';
  width: 2px;
  height: 0.3rem;
  background: #E25A4B;
  left: 0;
  top: .35rem;
}
.house-info .info {
  font-size .34rem
  font-weight bold
  color #333333
  line-height .8rem
  width 100%
  text-align center
}
.money-info {
  margin-top: .6rem
  display: flex;
  align-items: center;
  justify-content: center;  
  height: 1rem;
}
.houseBox {
  width 100%
  box-sizing border-box
  font-size .26rem
  line-height .54rem
  color #333333
}
.hs1{
  display inline-block
  width 1.5rem
  color #666666
}
.otherHouse{
  padding-top .3rem
}
.money-info {
  margin-top .6rem
  display flex
  align-items center
  justify-content center
  height .6rem
  width 6.9rem
  margin 0 auto
  margin-top .3rem
}
.money-info .lable {
  font-size: .28rem;
  color: #333333;
  font-weight: bold;
}
.money-info .info {
  flex 1
  padding-left .2rem
  color #E6002D
  font-size .36rem
  font-weight bold
}
.line-layer {
  width 6.9rem
  margin 0 auto
  height 3px
  background-color #F2F2F2
}
.money-warn{
  width 6.9rem
  color #EA8C58
  font-size .26rem
  line-height .34rem
  margin 0 auto
  margin-top .4rem
}
.sureBtn {
  width 6.9rem
  height 0.8rem
  margin 0 auto
  margin-top .3rem
  margin-bottom .4rem
  text-align center
  line-height 0.8rem
  color white
  font-size 0.3rem
  background #E6002D
  border-radius 5px
}
.noSure{
  background #cdcdcd
}
.wranTitle {
  display flex
  width 6rem
  margin 0 auto
  margin-top 0.65rem
  line-height 31px
  height 31px
}

.line {
  height 1px
  background #F2F2F2
  flex 1
  margin-top 15px
}

.wran {
  color #999999
  flex 1
  text-align center
}

.wranText {
  width 6rem
  margin 0.2rem auto
  text-align center
  color #666666
  font-size 0.24rem
  line-height 0.4rem
}
.plan{
  padding .35rem .3rem
  border-bottom .2rem solid #FAFAFA
}
.planBox{
  width 6.9rem
  border 1px solid #B5B5B5
  border-radius 10px
  padding .3rem
  box-sizing border-box
}
.planBox p{
  line-height .54rem
}
.planBox p.pw{
  color #333333
  font-weight bold
}
.planTitle{
  line-height .54rem
  color #333333
  margin .1rem 0
}
.timeBox{
  width 100%
  height .6rem
  line-height .6rem
  text-align center
  background #00479D
  color white
  position fixed
  left 0
  top 0
  opacity .9
  font-size .26rem
}
.timeBox span{
  font-size .18rem
}
</style>